import store from "../../store"
import permitirVendaSemEstoque from "./permitirVendaSemEstoque"
import calculaDesconto from "./calculaDesconto"
import axios from "axios"

export default async () => {
    axios.defaults.headers.common['Authorization'] = `Bearer 39005d6c0b6c49acb6bf50afb54d86cb`
    const response = await axios.get(`https://api.sicecommerce.com.br/catalogos/${store.getters.catalogo.id}/itens?limit=null`)
    const itens = response.data.itens

    store.getters.cartProducts.map((produto) => {

        const produtoExiste = itens.find((i) => i.codigo === produto.codigo)
        // eslint-disable-next-line no-console
        //console.log('error.response');
        
        let skuValido = true
        let sku
        let estoque = produtoExiste?.estoque

        if (!(JSON.stringify(produto.skuSelecionado) === '{}')) {
            sku = produtoExiste.skus.find((i) => i.sku === produto.skuSelecionado.sku)
            estoque = sku.saldo
            skuValido = sku ? true : false
        }

        if (!produtoExiste || (!permitirVendaSemEstoque() && estoque < 1) || !skuValido)
            store.dispatch('delToCart', produto)
        else {
            const quantidade = (permitirVendaSemEstoque() || estoque >= produto.quantidade) ? produto.quantidade : estoque

            produto.cadastroProduto = produtoExiste
            produto.descricao = produtoExiste.descricao
            produto.quantidade = parseFloat(quantidade.toString().replace(',', '.'))
            produto.valorUnitario = calculaDesconto(
                produtoExiste.precos[0].precodinheiro,
                produtoExiste.precos[0].percpromocao,
                produtoExiste.precos[0].promoqtapartirde,
                parseFloat(produto.quantidade)
            )
            produto.imagem = sku ? (sku.skuimagens[0] ? sku.skuimagens[0].url_img : '/img/produto.7e9078e7.png') : produtoExiste.imagens[0].url_img
            produto.operacao = 'ALTER_ITEM_CART'
            store.dispatch('addToCart', produto)
        }
    })
}